import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-user-district",
  templateUrl: "./user-district.component.html",
  styleUrls: ["./user-district.component.scss"],
})
export class UserDistrictComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  UserID: any;
  Data: any;
  isLoading: boolean;
  user: any;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private datepipe: DatePipe,
    private gs: GeneralService,
    private http: HttpClient
  ) {
    let a = this.router.getCurrentNavigation().extras;
    if (a) {
      if (a.state) {
        this.UserID = a.state.UserId;
        console.log("thisuserid", a.state);
        localStorage.setItem("UserId", this.UserID);
      }
    }
    if (localStorage.getItem("UserId")) {
      this.UserID = localStorage.getItem("UserId");
    }
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "User District", path: "/", active: true },
    ];
  }

  ngOnInit() {
    this.getusersbyid();
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      ordering: true,
      searching: true,
      ajax: (dataTablesParameters: any, callback) => {
        // console.log("lin")
        this.http
          .get<DataTablesResponse>(
            `${this.gs.userDistrictList()}` +
              `?UserID=${this.UserID}` +
              `&PageNo=${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
              }` +
              `${
                dataTablesParameters.length.value != ""
                  ? "&PageSize=" + dataTablesParameters.length
                  : ""
              }` +
              `${
                dataTablesParameters.search.value != ""
                  ? "&search=" + dataTablesParameters.search.value
                  : ""
              }`
          )
          .subscribe((resp: any) => {
            // console.log("Area Alert",resp)
            callback({
              recordsTotal: resp.TotalCount,
              recordsFiltered: resp.TotalCount,
              data: resp.data,
            });
          });
      },
      columns: [
        {
          title: "ID",
          data: null,
          render: (data) => {
            return data.UserDistrictID ? data.UserDistrictID : "--";
          },
        },
        {
          title: "Entry_Date",
          data: null,
          render: (data) => {
            if (
              data.created_date === "0000-00-00" ||
              data.created_date == null
            ) {
              return "--";
            } else {
              return this.datepipe.transform(data.created_date, "yyyy-MM-dd");
            }
          },
        },
        {
          title: "District Name",
          data: null,
          render: (data) => {
            return data.DistrictName ? data.DistrictName : "--";
          },
        },
        {
          title: "Action",
          name: "id",
          orderable: false,
          data: null,
          render(data) {
            // console.log("198",data)
            return `<div style="display:flex">
            <a title="Delete District"> <i style="display:flex;margin-top: 14px; cursor:pointer;font-size: 20px; color:#c20615"class="material-icons"  UserId="${data.UserDistrictID}">delete</i></a>
          `;
          },
        },
      ],
      drawCallback: () => {
        $(".material-icons").on("click", (e) => {
          this.delete(e.target.getAttribute("UserId"));
        });
      },
    };
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  district() {
    this.router.navigate(["users/add-user-district"], {
      state: {
        UserId: this.UserID,
        Editproperty: false,
        isEdit: false,
        isLoading: false,
      },
    });
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  delete(id) {
    // console.log("262",id)
    this.isLoading = true;
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this User District?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonClass: "btn btn-danger mt-2",
      cancelButtonClass: "btn btn-success ml-2 mt-2",
      buttonsStyling: false,
      showConfirmButton: true,
    }).then((result) => {
      if (result.value) {
        this.gs.deleteUserDetail(id).subscribe((res) => {
          // console.log("Delete",res)
          Swal.fire({
            title: "Success",
            text: "Data Deleted successfully.",
            type: "success",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.rerender();
          });
          this.isLoading = false;
        });
      }
    });
  }
  getusersbyid() {
    this.isLoading = true;
    this.gs.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        console.log("res", res.data[0]);

        this.isLoading = false;
        this.user = res.data[0];
        // this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanId", this.user.plan_id);
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
}
